import { Component, OnInit, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { takeUntil } from 'rxjs/operators';

import { User } from '@shared/models/user.model';
import { UserService } from '@shared/services/user.service';
import { TakeUntilDestroy } from '@shared/decorators/take-until-destroy.decorator';
import { HelperService } from '@shared/services/helper.service';
import { Modal, ModalType, NonPersistedModalName } from '@app/shared/models/modal.model';
import { LoggerService } from '@app/shared/services/logger.service';
import { Observable } from 'rxjs';
import { EventManager } from '@app/shared/utils/event-manager';
import { SharedModule } from '@app/shared/shared.module';
import { BannerComponent } from '@app/shared/components/banner/banner.component';
import { ProfileHeaderComponent } from '@app/home/profile/profile-header/profile-header.component';
import { ProfileTabsComponent } from '@app/home/profile/profile-tabs/profile-tabs.component';

@TakeUntilDestroy
@Component({
  selector: 'slotcom-public-profile',
  templateUrl: './public-profile.component.html',
  styleUrls: ['./public-profile.component.scss'],
  standalone: true,
  imports: [SharedModule, BannerComponent, ProfileHeaderComponent, ProfileTabsComponent],
})
export class PublicProfileComponent implements OnInit {
  isSelf = signal(false);
  userId: string;
  currentUser: User;
  profileUser = signal<User | null>(null);
  componentDestroy: () => Observable<unknown>;

  urlBanner: object;
  selectedTab = 0;

  private readonly userService = inject(UserService);
  public readonly logger = inject(LoggerService);
  private readonly publicProfileModalData = inject<Modal>(MAT_DIALOG_DATA, { optional: true });
  private readonly helper = inject(HelperService);
  private readonly eventManager = inject(EventManager);

  ngOnInit() {
    this.userService.currentUser$.pipe(takeUntil(this.componentDestroy())).subscribe({
      next: (user: User) => {
        this.currentUser = user;
        this.setProfileUser();
      },
      error: (error) => this.logger.error(error),
    });
    this.urlBanner = this.setBanner();
  }

  setProfileUser() {
    if (!this.currentUser) return;

    if (!this.publicProfileModalData || this.currentUser.id === this.publicProfileModalData.data.userId) {
      this.isSelf.set(true);
      this.profileUser.set(this.currentUser);
    } else {
      this.getProfileUser();
    }
  }

  getProfileUser() {
    this.userService
      .getUser(this.publicProfileModalData.data.userId)
      .pipe(takeUntil(this.componentDestroy()))
      .subscribe({
        next: (user: User) => {
          this.isSelf.set(false);
          this.profileUser.set(user);
        },
        error: (error) => this.logger.error(error),
      });
  }

  setBanner() {
    const path = `/images/home/profile/banner/desktop.jpg`;
    const url = this.helper.getCloudServiceCdnContent(path);
    return { 'background-image': `url('${url}')` };
  }

  setSelectedTab(tabIndex: number) {
    this.selectedTab = tabIndex;
  }

  closeModal(): void {
    this.eventManager.closeModal(new Modal(NonPersistedModalName.PublicProfileComponent, ModalType.View));
  }
}
